"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var WirelessInsuranceState_1 = require("./WirelessInsuranceState");
var ReportingService_1 = require("../../../../api/ReportingService");
var Api_1 = require("../../../../api/Api");
var StateProvider_1 = require("../../../../api/StateProvider");
var insurance_modal_duc2_0_1 = require("@sales/insurance-modal-duc2.0");
var CartActions_1 = require("../../../../models/requests/CartActions");
var Utils = require("../../../../utils/UtilityFunctions");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var styles = require("./WirelessInsuarance.scss");
var stylesW = require("../WirelessCart.scss");
var WirelessInsurance = /** @class */ (function (_super) {
    __extends(WirelessInsurance, _super);
    function WirelessInsurance(props) {
        var _this = _super.call(this, props) || this;
        _this.insuranceNoThanksOfferId = 'NA';
        _this.reportingService = new ReportingService_1.default();
        _this.state = new WirelessInsuranceState_1.WirelessInsuranceState();
        _this.api = new Api_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.onNoThanksSelection = _this.onNoThanksSelection.bind(_this);
        _this.onChangeInsurancePlan = _this.onChangeInsurancePlan.bind(_this);
        _this.changeInsurancePlan = _this.changeInsurancePlan.bind(_this);
        _this.onUpdateCookie = _this.onUpdateCookie.bind(_this);
        _this.makeCookie = _this.makeCookie.bind(_this);
        _this.createInsuranceRequestObject = _this.createInsuranceRequestObject.bind(_this);
        _this.insurancePanelOnClick = _this.insurancePanelOnClick.bind(_this);
        _this.modalPageLoadEvent = _this.modalPageLoadEvent.bind(_this);
        return _this;
    }
    WirelessInsurance.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        var insuranceItems = this.props.insuranceItems;
        if (!insuranceItems || insuranceItems.length === 0) {
            return (React.createElement(React.Fragment, null));
        }
        this.currentSelectedInsurance = {};
        if (this.props.lineItems) {
            Object.values(this.props.lineItems).forEach(function (e) {
                var _a, _b;
                if (((_a = e === null || e === void 0 ? void 0 : e.itemType) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === 'feature' && ((_b = e === null || e === void 0 ? void 0 : e.productSubType) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === 'insurance') {
                    _this.currentSelectedInsurance = e;
                }
            });
        }
        var mrcValue = Math.trunc((_b = (_a = this.currentSelectedInsurance) === null || _a === void 0 ? void 0 : _a.price) === null || _b === void 0 ? void 0 : _b.amount);
        var uomValue = 'month';
        var mdpInsurance = false;
        var mdpInsuranceIndex = -1;
        insuranceItems.forEach(function (item, index) {
            var _a, _b, _c, _d, _e;
            if ((item === null || item === void 0 ? void 0 : item.offerId) === ((_a = _this.currentSelectedInsurance) === null || _a === void 0 ? void 0 : _a.offerId)) {
                (_b = item === null || item === void 0 ? void 0 : item.product) === null || _b === void 0 ? void 0 : _b.childSkus.forEach(function (sku) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    if ((sku === null || sku === void 0 ? void 0 : sku.skuId) === ((_a = _this.currentSelectedInsurance) === null || _a === void 0 ? void 0 : _a.productSKU) && ((_c = (_b = item === null || item === void 0 ? void 0 : item.product) === null || _b === void 0 ? void 0 : _b.price) === null || _c === void 0 ? void 0 : _c.mrc) && ((_e = (_d = item === null || item === void 0 ? void 0 : item.product) === null || _d === void 0 ? void 0 : _d.price) === null || _e === void 0 ? void 0 : _e.uom)) {
                        mrcValue = (_g = (_f = item === null || item === void 0 ? void 0 : item.product) === null || _f === void 0 ? void 0 : _f.price) === null || _g === void 0 ? void 0 : _g.mrc;
                        uomValue = (_j = (_h = item === null || item === void 0 ? void 0 : item.product) === null || _h === void 0 ? void 0 : _h.price) === null || _j === void 0 ? void 0 : _j.uom;
                    }
                });
                if (((_d = (_c = _this.currentSelectedInsurance) === null || _c === void 0 ? void 0 : _c._itemExtraAttributes) === null || _d === void 0 ? void 0 : _d.InsuranceType) === 'MDPP') {
                    mdpInsurance = true;
                }
            }
            (_e = item === null || item === void 0 ? void 0 : item.product) === null || _e === void 0 ? void 0 : _e.childSkus.forEach(function (sku) {
                if ((sku === null || sku === void 0 ? void 0 : sku.insuranceType) === 'MDPP') {
                    mdpInsuranceIndex = index;
                }
            });
        });
        var updateInsuranceItems = JSON.parse(JSON.stringify(insuranceItems));
        if (((_c = this.props) === null || _c === void 0 ? void 0 : _c.isMDPPInsurancePresent) && !mdpInsurance && mdpInsuranceIndex >= 0) {
            // MDPP will show only for applied line if added
            updateInsuranceItems.splice(mdpInsuranceIndex, 1);
        }
        var formattedInsurance = {
            displayName: ((_d = this.currentSelectedInsurance) === null || _d === void 0 ? void 0 : _d.displayName) ? (_e = this.currentSelectedInsurance) === null || _e === void 0 ? void 0 : _e.displayName : '',
            offerId: ((_f = this.currentSelectedInsurance) === null || _f === void 0 ? void 0 : _f.offerId) ? (_g = this.currentSelectedInsurance) === null || _g === void 0 ? void 0 : _g.offerId : 'NA',
            price: {
                mrc: ((_h = this.currentSelectedInsurance) === null || _h === void 0 ? void 0 : _h.displayName) ? mrcValue : null,
                uom: ((_j = this.currentSelectedInsurance) === null || _j === void 0 ? void 0 : _j.displayName) ? uomValue : '',
            },
        };
        var deviceFullPrice = {
            price: (_m = (_l = (_k = this.props.deviceLineItem) === null || _k === void 0 ? void 0 : _k.contractDetails) === null || _l === void 0 ? void 0 : _l.totalSalePrice) === null || _m === void 0 ? void 0 : _m.toString(),
        };
        var letUpdateZipCode = false;
        var campaignId = Utils.getCampaignSessionId();
        var divStyle = ((_q = (_p = (_o = this.props) === null || _o === void 0 ? void 0 : _o.losg) === null || _p === void 0 ? void 0 : _p.losgType) === null || _q === void 0 ? void 0 : _q.toUpperCase()) !== 'NEW' ? styles.upAlMargin : 'bottomspacer';
        return (React.createElement(React.Fragment, null,
            React.createElement("section", null,
                React.createElement("div", { className: stylesW.expupDivider }),
                React.createElement("div", { className: divStyle },
                    React.createElement(insurance_modal_duc2_0_1.InsuranceModal, { className: styles.roundBorder + " " + styles.typeBase + " " + styles.mobileView, changeInsurancePlan: this.onChangeInsurancePlan, currentSelection: formattedInsurance, deviceFullPrice: deviceFullPrice, expandOnLoad: false, hideDescription: true, 
                        // tslint:disable-next-line: jsx-no-lambda
                        insurancePanelOnClick: this.insurancePanelOnClick, insuranceResponseObject: updateInsuranceItems, 
                        // tslint:disable-next-line: jsx-no-lambda
                        insuranceSelectionEvent: function (insurance) { return console.log(insurance); }, letUpdateZipCode: letUpdateZipCode, 
                        // tslint:disable-next-line: jsx-no-lambda
                        modalPageLoadEvent: this.modalPageLoadEvent, noThanksSelected: this.onNoThanksSelection, 
                        // tslint:disable-next-line: jsx-no-lambda
                        onLinkClick: function (linkName) { return console.log({ linkName: linkName }); }, productCode: (_s = (_r = this.props) === null || _r === void 0 ? void 0 : _r.deviceLineItem) === null || _s === void 0 ? void 0 : _s.productCode, showModal: true, skuID: (_t = this.props.deviceLineItem) === null || _t === void 0 ? void 0 : _t.productSKU, updateCookie: this.onUpdateCookie, campaignIdHeader: campaignId, 
                        // tslint:disable-next-line: jsx-no-lambda
                        zipCodeValidationEvent: function (e1, e2, ln, sf, stC, stm, zip) { return console.log({
                            e1: e1, e2: e2, ln: ln, sf: sf, stC: stC, stm: stm, zip: zip,
                        }); } })))));
    };
    WirelessInsurance.prototype.onNoThanksSelection = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var insuranceItem, addTocartRequest;
            return __generator(this, function (_b) {
                if (this.currentSelectedInsurance && ((_a = this.currentSelectedInsurance) === null || _a === void 0 ? void 0 : _a.offerId)) {
                    insuranceItem = {};
                    addTocartRequest = this.createInsuranceRequestObject(insuranceItem, this.currentSelectedInsurance, CartActions_1.ActionType.REMOVE);
                    this.changeInsurancePlan(addTocartRequest, CartActions_1.ActionType.REMOVE);
                }
                return [2 /*return*/];
            });
        });
    };
    WirelessInsurance.prototype.insurancePanelOnClick = function (insuranceType, expanded) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var insurancelinkName;
            return __generator(this, function (_b) {
                insurancelinkName = ((_a = this.currentSelectedInsurance) === null || _a === void 0 ? void 0 : _a.itemType) ? 'Edit Insurance On Cart' : 'Add Insurance On Cart';
                this.reportingService.fireLinkClickWithOutDestination(insurancelinkName);
                return [2 /*return*/];
            });
        });
    };
    WirelessInsurance.prototype.modalPageLoadEvent = function (modalPageLoadValues) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (modalPageLoadValues &&
                    ((modalPageLoadValues === null || modalPageLoadValues === void 0 ? void 0 : modalPageLoadValues.friendlyPageName) || (modalPageLoadValues === null || modalPageLoadValues === void 0 ? void 0 : modalPageLoadValues.onClick))) {
                    this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.INSURANCE_MODAL_URL);
                }
                return [2 /*return*/];
            });
        });
    };
    WirelessInsurance.prototype.onChangeInsurancePlan = function (insuranceItem) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var actionType, addTocartRequest;
            return __generator(this, function (_b) {
                if ((insuranceItem === null || insuranceItem === void 0 ? void 0 : insuranceItem.offerId) === this.insuranceNoThanksOfferId) {
                    return [2 /*return*/];
                }
                actionType = CartActions_1.ActionType.ADD;
                if (this.currentSelectedInsurance) {
                    if ((insuranceItem === null || insuranceItem === void 0 ? void 0 : insuranceItem.offerId) === ((_a = this.currentSelectedInsurance) === null || _a === void 0 ? void 0 : _a.offerId)) {
                        return [2 /*return*/];
                    }
                    else {
                        actionType = CartActions_1.ActionType.MODIFY;
                    }
                }
                addTocartRequest = this.createInsuranceRequestObject(insuranceItem, this.currentSelectedInsurance, actionType);
                this.changeInsurancePlan(addTocartRequest, actionType);
                return [2 /*return*/];
            });
        });
    };
    WirelessInsurance.prototype.onUpdateCookie = function (name, value, type, path, lifeSpan, domain, isSessionCookie) {
        if (!name) {
            name = 'attPersistantLocalization';
        }
        var cookieValue = Utils.getCookie(name);
        if (type) {
            document.cookie = this.makeCookie(name, cookieValue, path, lifeSpan, domain, isSessionCookie);
        }
        else {
            var index1 = cookieValue.indexOf('=') + 1;
            var Value1 = cookieValue.substring(index1, value.length);
            document.cookie = this.makeCookie(name, Value1, path, lifeSpan, domain, isSessionCookie);
        }
    };
    WirelessInsurance.prototype.makeCookie = function (name, value, path, lifeSpan, domain, isSessionCookie) {
        lifeSpan = lifeSpan || (365 * 5);
        var date = new Date();
        date.setTime(date.getTime() + (lifeSpan * 24 * 60 * 60 * 1000));
        return name + "=" + value + "; domain=" + (domain || document.domain) + "; path=" + (path || window.location.hostname) + ";\n         expires=" + (isSessionCookie ? 0 : date.toUTCString());
    };
    WirelessInsurance.prototype.createInsuranceRequestObject = function (insurance, previousInsurance, actionType) {
        var lobItem;
        var losgId = this.props.losg.id;
        var losgType = this.props.losg.losgType;
        var portInIntentIndicator = false;
        var hylaTradeInIntentIndicator = true;
        if (CartUtilFunctions_1.getTradeInPortInConsented().portInCustomerConsented !== undefined &&
            CartUtilFunctions_1.getTradeInPortInConsented().portInCustomerConsented) {
            portInIntentIndicator = CartUtilFunctions_1.getTradeInPortInConsented().portInCustomerConsented;
        }
        if (CartUtilFunctions_1.getTradeInPortInConsented().hylatradeInCustomerConsented !== undefined &&
            CartUtilFunctions_1.getTradeInPortInConsented().hylatradeInCustomerConsented) {
            hylaTradeInIntentIndicator = !CartUtilFunctions_1.getTradeInPortInConsented().hylatradeInCustomerConsented;
        }
        var addTocartRequest = {
            itemsList: [],
            portInIntentIndicator: portInIntentIndicator,
            serviceContext: {
                srcSystem: 'IDSE',
            },
            shoppingContext: {
                actionType: 'PSC_ADD_TO_CART_REQUEST',
                cartCreationSource: this.props.cartCreationSource,
                hylaTradeInIntentRejected: hylaTradeInIntentIndicator,
                paymentType: '',
            },
        };
        if (CartUtilFunctions_1.isFNIntentPresent()) {
            addTocartRequest.shoppingContext.fnIntendInd = true;
        }
        if (CartUtilFunctions_1.isFNUserWithConsumerLine()) {
            addTocartRequest.shoppingContext.firstNetUser = true;
        }
        if (actionType === CartActions_1.ActionType.REMOVE) {
            lobItem = {
                action: CartActions_1.ActionType.REMOVE,
                continueCurrentCart: false,
                itemId: previousInsurance.id,
                itemType: CartActions_1.ItemType.FEATURE,
                losgId: losgId,
                losgType: losgType ? losgType : CartActions_1.LosgType.NEW,
                offerId: previousInsurance.offerId,
                productGroup: 'WIRELESS',
                productSKU: previousInsurance.productSKU,
                quantity: 1,
            };
        }
        else if (actionType === CartActions_1.ActionType.MODIFY) {
            lobItem = {
                action: CartActions_1.ActionType.MODIFY,
                continueCurrentCart: false,
                itemId: previousInsurance.id,
                itemType: CartActions_1.ItemType.FEATURE,
                losgId: losgId,
                losgType: losgType ? losgType : CartActions_1.LosgType.NEW,
                offerId: insurance === null || insurance === void 0 ? void 0 : insurance.offerId,
                productGroup: 'WIRELESS',
                productSKU: insurance === null || insurance === void 0 ? void 0 : insurance.skuId,
                quantity: 1,
            };
        }
        else if (actionType === CartActions_1.ActionType.ADD) {
            lobItem = {
                action: CartActions_1.ActionType.ADD,
                continueCurrentCart: false,
                itemId: null,
                itemType: CartActions_1.ItemType.FEATURE,
                losgId: losgId,
                losgType: losgType ? losgType : CartActions_1.LosgType.NEW,
                offerId: insurance === null || insurance === void 0 ? void 0 : insurance.offerId,
                productGroup: 'WIRELESS',
                productSKU: insurance === null || insurance === void 0 ? void 0 : insurance.skuId,
                quantity: 1,
            };
        }
        addTocartRequest.itemsList.push(lobItem);
        return addTocartRequest;
    };
    WirelessInsurance.prototype.changeInsurancePlan = function (addTocartRequest, actiontype) {
        return __awaiter(this, void 0, void 0, function () {
            var reportingServiceComment_1;
            var _this = this;
            return __generator(this, function (_a) {
                if ((addTocartRequest === null || addTocartRequest === void 0 ? void 0 : addTocartRequest.itemsList) && (addTocartRequest === null || addTocartRequest === void 0 ? void 0 : addTocartRequest.itemsList.length) > 0) {
                    reportingServiceComment_1 = 'Change Insurance';
                    if (actiontype === CartActions_1.ActionType.ADD) {
                        reportingServiceComment_1 = 'Insurance Added';
                    }
                    if (actiontype === CartActions_1.ActionType.MODIFY) {
                        reportingServiceComment_1 = 'Insurance Upgraded';
                    }
                    if (actiontype === CartActions_1.ActionType.REMOVE) {
                        reportingServiceComment_1 = 'Insurance Removed';
                    }
                    this.reportingService.fireCartUpdateSubmitEvent(false, '-2', ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, reportingServiceComment_1, JSON.stringify(addTocartRequest), CartUtilFunctions_1.getLinkClickBasekUrl());
                    this.props.events.doLoading(true);
                    this.api.addToCart(addTocartRequest).then(function (data) {
                        _this.props.events.doLoading(false);
                        if (data && data.content && data.content.payload && data.content.payload.wirelessCart) {
                            _this.reportingService.fireCartUpdateSubmitEvent(false, '0', ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, reportingServiceComment_1, JSON.stringify(data), CartUtilFunctions_1.getLinkClickBasekUrl());
                            _this.stateManager.set('cartUpdate', { cartRefresh: true });
                            _this.stateManager.set('deviceUpdate', { deviceConfigRefresh: true });
                        }
                    }).catch(function (error) {
                        _this.props.events.doLoading(false);
                        _this.reportingService.fireCartUpdateSubmitEvent(false, error && error.errorId, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, reportingServiceComment_1, JSON.stringify(error), CartUtilFunctions_1.getLinkClickBasekUrl());
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    return WirelessInsurance;
}(React.Component));
exports.default = WirelessInsurance;
//# sourceMappingURL=WirelessInsurance.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/WirelessInsurance/WirelessInsurance.js
// module id = 777
// module chunks = 8